// Por que um e-mail não virou chamado, em português.
//
// As chaves são as MESMAS de `Services\Email\TriagemDeEmail::MOTIVOS` na api,
// porque é a string crua que viaja no payload. O rótulo é só da tela.
//
// Separado da tela porque a lista de descartados e o botão de "bloquear este
// remetente" usam o mesmo vocabulário: sem um lugar só, a tela acabaria com
// uma comparação contra `'remetente_bloqueado'` escrita à mão no meio do JSX
// -- e um erro de digitação ali não dá erro nenhum, só faz o botão aparecer
// onde não devia.

export const MOTIVOS_DE_DESCARTE = {
    REMETENTE_BLOQUEADO: 'remetente_bloqueado',
    SPAM_DO_SERVIDOR: 'spam_do_servidor',
    AUTOMATICO: 'automatico',
};

const ROTULOS = {
    [MOTIVOS_DE_DESCARTE.REMETENTE_BLOQUEADO]: 'Remetente bloqueado',
    [MOTIVOS_DE_DESCARTE.SPAM_DO_SERVIDOR]: 'Spam',
    [MOTIVOS_DE_DESCARTE.AUTOMATICO]: 'Mensagem automática',
};

/**
 * O rótulo de um motivo.
 *
 * Motivo desconhecido devolve ele mesmo, e não um traço: se a api ganhar uma
 * regra nova antes da tela, é melhor mostrar a chave crua do que esconder a
 * informação de que algo foi barrado por um motivo que esta tela não conhece.
 */
export function rotuloDoDescarte(motivo) {
    return ROTULOS[motivo] || String(motivo || '—');
}

export default rotuloDoDescarte;
